var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.833 24.5c0-1.86 0-2.791-.23-3.548a5.33 5.33 0 0 0-3.555-3.556c-.757-.23-1.687-.23-3.548-.23H7.833c-1.86 0-2.79 0-3.548.23A5.33 5.33 0 0 0 .73 20.952C.5 21.709.5 22.639.5 24.5m16.667-18a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
  })));
};
export default SvgUser;